/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TrendsRouteImport } from './routes/trends'
import { Route as ToolsRouteImport } from './routes/tools'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as ReportsRouteImport } from './routes/reports'
import { Route as QualityRouteImport } from './routes/quality'
import { Route as PredictionsRouteImport } from './routes/predictions'
import { Route as InsightsRouteImport } from './routes/insights'
import { Route as GraphRouteImport } from './routes/graph'
import { Route as DependenciesRouteImport } from './routes/dependencies'
import { Route as CoverageRouteImport } from './routes/coverage'
import { Route as CompareRouteImport } from './routes/compare'
import { Route as AnalyticsRouteImport } from './routes/analytics'
import { Route as IndexRouteImport } from './routes/index'
import { Route as DashboardIndexRouteImport } from './routes/dashboard/index'
import { Route as DashboardTrendsIndexRouteImport } from './routes/dashboard/trends/index'
import { Route as DashboardToolsIndexRouteImport } from './routes/dashboard/tools/index'
import { Route as DashboardSettingsIndexRouteImport } from './routes/dashboard/settings/index'
import { Route as DashboardReportsIndexRouteImport } from './routes/dashboard/reports/index'
import { Route as DashboardQualityIndexRouteImport } from './routes/dashboard/quality/index'
import { Route as DashboardPredictionsIndexRouteImport } from './routes/dashboard/predictions/index'
import { Route as DashboardInsightsIndexRouteImport } from './routes/dashboard/insights/index'
import { Route as DashboardGraphIndexRouteImport } from './routes/dashboard/graph/index'
import { Route as DashboardDependenciesIndexRouteImport } from './routes/dashboard/dependencies/index'
import { Route as DashboardCoverageIndexRouteImport } from './routes/dashboard/coverage/index'
import { Route as DashboardCompareIndexRouteImport } from './routes/dashboard/compare/index'
import { Route as DashboardAnalyticsIndexRouteImport } from './routes/dashboard/analytics/index'
import { Route as DashboardToolsModuleIdRouteImport } from './routes/dashboard/tools/$moduleId'
import { Route as DashboardToolsCandidateCandidateNameRouteImport } from './routes/dashboard/tools/candidate/$candidateName'

const TrendsRoute = TrendsRouteImport.update({
  id: '/trends',
  path: '/trends',
  getParentRoute: () => rootRouteImport,
} as any)
const ToolsRoute = ToolsRouteImport.update({
  id: '/tools',
  path: '/tools',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsRoute = SettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const ReportsRoute = ReportsRouteImport.update({
  id: '/reports',
  path: '/reports',
  getParentRoute: () => rootRouteImport,
} as any)
const QualityRoute = QualityRouteImport.update({
  id: '/quality',
  path: '/quality',
  getParentRoute: () => rootRouteImport,
} as any)
const PredictionsRoute = PredictionsRouteImport.update({
  id: '/predictions',
  path: '/predictions',
  getParentRoute: () => rootRouteImport,
} as any)
const InsightsRoute = InsightsRouteImport.update({
  id: '/insights',
  path: '/insights',
  getParentRoute: () => rootRouteImport,
} as any)
const GraphRoute = GraphRouteImport.update({
  id: '/graph',
  path: '/graph',
  getParentRoute: () => rootRouteImport,
} as any)
const DependenciesRoute = DependenciesRouteImport.update({
  id: '/dependencies',
  path: '/dependencies',
  getParentRoute: () => rootRouteImport,
} as any)
const CoverageRoute = CoverageRouteImport.update({
  id: '/coverage',
  path: '/coverage',
  getParentRoute: () => rootRouteImport,
} as any)
const CompareRoute = CompareRouteImport.update({
  id: '/compare',
  path: '/compare',
  getParentRoute: () => rootRouteImport,
} as any)
const AnalyticsRoute = AnalyticsRouteImport.update({
  id: '/analytics',
  path: '/analytics',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardIndexRoute = DashboardIndexRouteImport.update({
  id: '/dashboard/',
  path: '/dashboard/',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardTrendsIndexRoute = DashboardTrendsIndexRouteImport.update({
  id: '/dashboard/trends/',
  path: '/dashboard/trends/',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardToolsIndexRoute = DashboardToolsIndexRouteImport.update({
  id: '/dashboard/tools/',
  path: '/dashboard/tools/',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardSettingsIndexRoute = DashboardSettingsIndexRouteImport.update({
  id: '/dashboard/settings/',
  path: '/dashboard/settings/',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardReportsIndexRoute = DashboardReportsIndexRouteImport.update({
  id: '/dashboard/reports/',
  path: '/dashboard/reports/',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardQualityIndexRoute = DashboardQualityIndexRouteImport.update({
  id: '/dashboard/quality/',
  path: '/dashboard/quality/',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardPredictionsIndexRoute =
  DashboardPredictionsIndexRouteImport.update({
    id: '/dashboard/predictions/',
    path: '/dashboard/predictions/',
    getParentRoute: () => rootRouteImport,
  } as any)
const DashboardInsightsIndexRoute = DashboardInsightsIndexRouteImport.update({
  id: '/dashboard/insights/',
  path: '/dashboard/insights/',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardGraphIndexRoute = DashboardGraphIndexRouteImport.update({
  id: '/dashboard/graph/',
  path: '/dashboard/graph/',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardDependenciesIndexRoute =
  DashboardDependenciesIndexRouteImport.update({
    id: '/dashboard/dependencies/',
    path: '/dashboard/dependencies/',
    getParentRoute: () => rootRouteImport,
  } as any)
const DashboardCoverageIndexRoute = DashboardCoverageIndexRouteImport.update({
  id: '/dashboard/coverage/',
  path: '/dashboard/coverage/',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardCompareIndexRoute = DashboardCompareIndexRouteImport.update({
  id: '/dashboard/compare/',
  path: '/dashboard/compare/',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardAnalyticsIndexRoute = DashboardAnalyticsIndexRouteImport.update({
  id: '/dashboard/analytics/',
  path: '/dashboard/analytics/',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardToolsModuleIdRoute = DashboardToolsModuleIdRouteImport.update({
  id: '/dashboard/tools/$moduleId',
  path: '/dashboard/tools/$moduleId',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardToolsCandidateCandidateNameRoute =
  DashboardToolsCandidateCandidateNameRouteImport.update({
    id: '/dashboard/tools/candidate/$candidateName',
    path: '/dashboard/tools/candidate/$candidateName',
    getParentRoute: () => rootRouteImport,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/analytics': typeof AnalyticsRoute
  '/compare': typeof CompareRoute
  '/coverage': typeof CoverageRoute
  '/dependencies': typeof DependenciesRoute
  '/graph': typeof GraphRoute
  '/insights': typeof InsightsRoute
  '/predictions': typeof PredictionsRoute
  '/quality': typeof QualityRoute
  '/reports': typeof ReportsRoute
  '/settings': typeof SettingsRoute
  '/tools': typeof ToolsRoute
  '/trends': typeof TrendsRoute
  '/dashboard': typeof DashboardIndexRoute
  '/dashboard/tools/$moduleId': typeof DashboardToolsModuleIdRoute
  '/dashboard/analytics': typeof DashboardAnalyticsIndexRoute
  '/dashboard/compare': typeof DashboardCompareIndexRoute
  '/dashboard/coverage': typeof DashboardCoverageIndexRoute
  '/dashboard/dependencies': typeof DashboardDependenciesIndexRoute
  '/dashboard/graph': typeof DashboardGraphIndexRoute
  '/dashboard/insights': typeof DashboardInsightsIndexRoute
  '/dashboard/predictions': typeof DashboardPredictionsIndexRoute
  '/dashboard/quality': typeof DashboardQualityIndexRoute
  '/dashboard/reports': typeof DashboardReportsIndexRoute
  '/dashboard/settings': typeof DashboardSettingsIndexRoute
  '/dashboard/tools': typeof DashboardToolsIndexRoute
  '/dashboard/trends': typeof DashboardTrendsIndexRoute
  '/dashboard/tools/candidate/$candidateName': typeof DashboardToolsCandidateCandidateNameRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/analytics': typeof AnalyticsRoute
  '/compare': typeof CompareRoute
  '/coverage': typeof CoverageRoute
  '/dependencies': typeof DependenciesRoute
  '/graph': typeof GraphRoute
  '/insights': typeof InsightsRoute
  '/predictions': typeof PredictionsRoute
  '/quality': typeof QualityRoute
  '/reports': typeof ReportsRoute
  '/settings': typeof SettingsRoute
  '/tools': typeof ToolsRoute
  '/trends': typeof TrendsRoute
  '/dashboard': typeof DashboardIndexRoute
  '/dashboard/tools/$moduleId': typeof DashboardToolsModuleIdRoute
  '/dashboard/analytics': typeof DashboardAnalyticsIndexRoute
  '/dashboard/compare': typeof DashboardCompareIndexRoute
  '/dashboard/coverage': typeof DashboardCoverageIndexRoute
  '/dashboard/dependencies': typeof DashboardDependenciesIndexRoute
  '/dashboard/graph': typeof DashboardGraphIndexRoute
  '/dashboard/insights': typeof DashboardInsightsIndexRoute
  '/dashboard/predictions': typeof DashboardPredictionsIndexRoute
  '/dashboard/quality': typeof DashboardQualityIndexRoute
  '/dashboard/reports': typeof DashboardReportsIndexRoute
  '/dashboard/settings': typeof DashboardSettingsIndexRoute
  '/dashboard/tools': typeof DashboardToolsIndexRoute
  '/dashboard/trends': typeof DashboardTrendsIndexRoute
  '/dashboard/tools/candidate/$candidateName': typeof DashboardToolsCandidateCandidateNameRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/analytics': typeof AnalyticsRoute
  '/compare': typeof CompareRoute
  '/coverage': typeof CoverageRoute
  '/dependencies': typeof DependenciesRoute
  '/graph': typeof GraphRoute
  '/insights': typeof InsightsRoute
  '/predictions': typeof PredictionsRoute
  '/quality': typeof QualityRoute
  '/reports': typeof ReportsRoute
  '/settings': typeof SettingsRoute
  '/tools': typeof ToolsRoute
  '/trends': typeof TrendsRoute
  '/dashboard/': typeof DashboardIndexRoute
  '/dashboard/tools/$moduleId': typeof DashboardToolsModuleIdRoute
  '/dashboard/analytics/': typeof DashboardAnalyticsIndexRoute
  '/dashboard/compare/': typeof DashboardCompareIndexRoute
  '/dashboard/coverage/': typeof DashboardCoverageIndexRoute
  '/dashboard/dependencies/': typeof DashboardDependenciesIndexRoute
  '/dashboard/graph/': typeof DashboardGraphIndexRoute
  '/dashboard/insights/': typeof DashboardInsightsIndexRoute
  '/dashboard/predictions/': typeof DashboardPredictionsIndexRoute
  '/dashboard/quality/': typeof DashboardQualityIndexRoute
  '/dashboard/reports/': typeof DashboardReportsIndexRoute
  '/dashboard/settings/': typeof DashboardSettingsIndexRoute
  '/dashboard/tools/': typeof DashboardToolsIndexRoute
  '/dashboard/trends/': typeof DashboardTrendsIndexRoute
  '/dashboard/tools/candidate/$candidateName': typeof DashboardToolsCandidateCandidateNameRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/analytics'
    | '/compare'
    | '/coverage'
    | '/dependencies'
    | '/graph'
    | '/insights'
    | '/predictions'
    | '/quality'
    | '/reports'
    | '/settings'
    | '/tools'
    | '/trends'
    | '/dashboard'
    | '/dashboard/tools/$moduleId'
    | '/dashboard/analytics'
    | '/dashboard/compare'
    | '/dashboard/coverage'
    | '/dashboard/dependencies'
    | '/dashboard/graph'
    | '/dashboard/insights'
    | '/dashboard/predictions'
    | '/dashboard/quality'
    | '/dashboard/reports'
    | '/dashboard/settings'
    | '/dashboard/tools'
    | '/dashboard/trends'
    | '/dashboard/tools/candidate/$candidateName'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/analytics'
    | '/compare'
    | '/coverage'
    | '/dependencies'
    | '/graph'
    | '/insights'
    | '/predictions'
    | '/quality'
    | '/reports'
    | '/settings'
    | '/tools'
    | '/trends'
    | '/dashboard'
    | '/dashboard/tools/$moduleId'
    | '/dashboard/analytics'
    | '/dashboard/compare'
    | '/dashboard/coverage'
    | '/dashboard/dependencies'
    | '/dashboard/graph'
    | '/dashboard/insights'
    | '/dashboard/predictions'
    | '/dashboard/quality'
    | '/dashboard/reports'
    | '/dashboard/settings'
    | '/dashboard/tools'
    | '/dashboard/trends'
    | '/dashboard/tools/candidate/$candidateName'
  id:
    | '__root__'
    | '/'
    | '/analytics'
    | '/compare'
    | '/coverage'
    | '/dependencies'
    | '/graph'
    | '/insights'
    | '/predictions'
    | '/quality'
    | '/reports'
    | '/settings'
    | '/tools'
    | '/trends'
    | '/dashboard/'
    | '/dashboard/tools/$moduleId'
    | '/dashboard/analytics/'
    | '/dashboard/compare/'
    | '/dashboard/coverage/'
    | '/dashboard/dependencies/'
    | '/dashboard/graph/'
    | '/dashboard/insights/'
    | '/dashboard/predictions/'
    | '/dashboard/quality/'
    | '/dashboard/reports/'
    | '/dashboard/settings/'
    | '/dashboard/tools/'
    | '/dashboard/trends/'
    | '/dashboard/tools/candidate/$candidateName'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AnalyticsRoute: typeof AnalyticsRoute
  CompareRoute: typeof CompareRoute
  CoverageRoute: typeof CoverageRoute
  DependenciesRoute: typeof DependenciesRoute
  GraphRoute: typeof GraphRoute
  InsightsRoute: typeof InsightsRoute
  PredictionsRoute: typeof PredictionsRoute
  QualityRoute: typeof QualityRoute
  ReportsRoute: typeof ReportsRoute
  SettingsRoute: typeof SettingsRoute
  ToolsRoute: typeof ToolsRoute
  TrendsRoute: typeof TrendsRoute
  DashboardIndexRoute: typeof DashboardIndexRoute
  DashboardToolsModuleIdRoute: typeof DashboardToolsModuleIdRoute
  DashboardAnalyticsIndexRoute: typeof DashboardAnalyticsIndexRoute
  DashboardCompareIndexRoute: typeof DashboardCompareIndexRoute
  DashboardCoverageIndexRoute: typeof DashboardCoverageIndexRoute
  DashboardDependenciesIndexRoute: typeof DashboardDependenciesIndexRoute
  DashboardGraphIndexRoute: typeof DashboardGraphIndexRoute
  DashboardInsightsIndexRoute: typeof DashboardInsightsIndexRoute
  DashboardPredictionsIndexRoute: typeof DashboardPredictionsIndexRoute
  DashboardQualityIndexRoute: typeof DashboardQualityIndexRoute
  DashboardReportsIndexRoute: typeof DashboardReportsIndexRoute
  DashboardSettingsIndexRoute: typeof DashboardSettingsIndexRoute
  DashboardToolsIndexRoute: typeof DashboardToolsIndexRoute
  DashboardTrendsIndexRoute: typeof DashboardTrendsIndexRoute
  DashboardToolsCandidateCandidateNameRoute: typeof DashboardToolsCandidateCandidateNameRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/trends': {
      id: '/trends'
      path: '/trends'
      fullPath: '/trends'
      preLoaderRoute: typeof TrendsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tools': {
      id: '/tools'
      path: '/tools'
      fullPath: '/tools'
      preLoaderRoute: typeof ToolsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reports': {
      id: '/reports'
      path: '/reports'
      fullPath: '/reports'
      preLoaderRoute: typeof ReportsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/quality': {
      id: '/quality'
      path: '/quality'
      fullPath: '/quality'
      preLoaderRoute: typeof QualityRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/predictions': {
      id: '/predictions'
      path: '/predictions'
      fullPath: '/predictions'
      preLoaderRoute: typeof PredictionsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/insights': {
      id: '/insights'
      path: '/insights'
      fullPath: '/insights'
      preLoaderRoute: typeof InsightsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/graph': {
      id: '/graph'
      path: '/graph'
      fullPath: '/graph'
      preLoaderRoute: typeof GraphRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dependencies': {
      id: '/dependencies'
      path: '/dependencies'
      fullPath: '/dependencies'
      preLoaderRoute: typeof DependenciesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/coverage': {
      id: '/coverage'
      path: '/coverage'
      fullPath: '/coverage'
      preLoaderRoute: typeof CoverageRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/compare': {
      id: '/compare'
      path: '/compare'
      fullPath: '/compare'
      preLoaderRoute: typeof CompareRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/analytics': {
      id: '/analytics'
      path: '/analytics'
      fullPath: '/analytics'
      preLoaderRoute: typeof AnalyticsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard/': {
      id: '/dashboard/'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof DashboardIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard/trends/': {
      id: '/dashboard/trends/'
      path: '/dashboard/trends'
      fullPath: '/dashboard/trends'
      preLoaderRoute: typeof DashboardTrendsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard/tools/': {
      id: '/dashboard/tools/'
      path: '/dashboard/tools'
      fullPath: '/dashboard/tools'
      preLoaderRoute: typeof DashboardToolsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard/settings/': {
      id: '/dashboard/settings/'
      path: '/dashboard/settings'
      fullPath: '/dashboard/settings'
      preLoaderRoute: typeof DashboardSettingsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard/reports/': {
      id: '/dashboard/reports/'
      path: '/dashboard/reports'
      fullPath: '/dashboard/reports'
      preLoaderRoute: typeof DashboardReportsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard/quality/': {
      id: '/dashboard/quality/'
      path: '/dashboard/quality'
      fullPath: '/dashboard/quality'
      preLoaderRoute: typeof DashboardQualityIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard/predictions/': {
      id: '/dashboard/predictions/'
      path: '/dashboard/predictions'
      fullPath: '/dashboard/predictions'
      preLoaderRoute: typeof DashboardPredictionsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard/insights/': {
      id: '/dashboard/insights/'
      path: '/dashboard/insights'
      fullPath: '/dashboard/insights'
      preLoaderRoute: typeof DashboardInsightsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard/graph/': {
      id: '/dashboard/graph/'
      path: '/dashboard/graph'
      fullPath: '/dashboard/graph'
      preLoaderRoute: typeof DashboardGraphIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard/dependencies/': {
      id: '/dashboard/dependencies/'
      path: '/dashboard/dependencies'
      fullPath: '/dashboard/dependencies'
      preLoaderRoute: typeof DashboardDependenciesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard/coverage/': {
      id: '/dashboard/coverage/'
      path: '/dashboard/coverage'
      fullPath: '/dashboard/coverage'
      preLoaderRoute: typeof DashboardCoverageIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard/compare/': {
      id: '/dashboard/compare/'
      path: '/dashboard/compare'
      fullPath: '/dashboard/compare'
      preLoaderRoute: typeof DashboardCompareIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard/analytics/': {
      id: '/dashboard/analytics/'
      path: '/dashboard/analytics'
      fullPath: '/dashboard/analytics'
      preLoaderRoute: typeof DashboardAnalyticsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard/tools/$moduleId': {
      id: '/dashboard/tools/$moduleId'
      path: '/dashboard/tools/$moduleId'
      fullPath: '/dashboard/tools/$moduleId'
      preLoaderRoute: typeof DashboardToolsModuleIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard/tools/candidate/$candidateName': {
      id: '/dashboard/tools/candidate/$candidateName'
      path: '/dashboard/tools/candidate/$candidateName'
      fullPath: '/dashboard/tools/candidate/$candidateName'
      preLoaderRoute: typeof DashboardToolsCandidateCandidateNameRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AnalyticsRoute: AnalyticsRoute,
  CompareRoute: CompareRoute,
  CoverageRoute: CoverageRoute,
  DependenciesRoute: DependenciesRoute,
  GraphRoute: GraphRoute,
  InsightsRoute: InsightsRoute,
  PredictionsRoute: PredictionsRoute,
  QualityRoute: QualityRoute,
  ReportsRoute: ReportsRoute,
  SettingsRoute: SettingsRoute,
  ToolsRoute: ToolsRoute,
  TrendsRoute: TrendsRoute,
  DashboardIndexRoute: DashboardIndexRoute,
  DashboardToolsModuleIdRoute: DashboardToolsModuleIdRoute,
  DashboardAnalyticsIndexRoute: DashboardAnalyticsIndexRoute,
  DashboardCompareIndexRoute: DashboardCompareIndexRoute,
  DashboardCoverageIndexRoute: DashboardCoverageIndexRoute,
  DashboardDependenciesIndexRoute: DashboardDependenciesIndexRoute,
  DashboardGraphIndexRoute: DashboardGraphIndexRoute,
  DashboardInsightsIndexRoute: DashboardInsightsIndexRoute,
  DashboardPredictionsIndexRoute: DashboardPredictionsIndexRoute,
  DashboardQualityIndexRoute: DashboardQualityIndexRoute,
  DashboardReportsIndexRoute: DashboardReportsIndexRoute,
  DashboardSettingsIndexRoute: DashboardSettingsIndexRoute,
  DashboardToolsIndexRoute: DashboardToolsIndexRoute,
  DashboardTrendsIndexRoute: DashboardTrendsIndexRoute,
  DashboardToolsCandidateCandidateNameRoute:
    DashboardToolsCandidateCandidateNameRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
